export class FileDownloader {
  static triggerDownload(blob: Blob, fileName: string): void {
    if (blob && blob.size > 0 && fileName) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  }
}
